import React from "react";
import { ArrowUpRight, Check } from "lucide-react";

export const ProjectPricing = ({ project }) => {
  const { pricing } = project;
  if (!pricing) return null;
  return (
    <section className="relative" style={{ paddingBottom: "clamp(48px, 8vh, 96px)" }} data-testid="project-pricing">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="ggm-eyebrow mb-4">Pricing</div>
        <p className="font-body text-white/70 max-w-3xl mb-8" data-testid="project-pricing-note">{pricing.note}</p>
        <div className="grid gap-5 md:grid-cols-3">
          {pricing.plans.map((p) => (
            <div
              key={p.name}
              className="relative rounded-md p-7 flex flex-col"
              style={{
                background: p.popular ? "var(--ggm-surface)" : "transparent",
                border: p.popular ? "2px solid var(--ggm-signal-cyan)" : "2px dashed rgba(230,237,247,0.25)",
                boxShadow: p.popular ? "8px 8px 0 var(--ggm-orbit-blue)" : "none",
              }}
              data-testid={`project-plan-${p.name.toLowerCase()}`}
            >
              {p.popular && (
                <span className="absolute -top-4 right-6 ggm-hand text-base px-3 py-0.5" style={{ background: "var(--ggm-tech-light)", color: "var(--ggm-orbit-blue)", transform: "rotate(3deg)" }}>
                  Most popular
                </span>
              )}
              <h3 className="font-condensed uppercase text-white text-xl">{project.name} {p.name}</h3>
              <p className="mt-1 font-body text-white/55 text-sm">{p.bestFor}</p>
              <div className="mt-5 flex items-baseline gap-2">
                <span className="font-condensed text-white text-4xl" data-testid={`project-plan-price-${p.name.toLowerCase()}`}>{p.price}</span>
                <span className="font-body text-white/50 text-sm">/ month · {p.users}</span>
              </div>
              <ul className="mt-5 space-y-2 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex gap-2 font-body text-sm text-white/75">
                    <Check size={16} className="mt-0.5 shrink-0 text-[var(--ggm-signal-cyan)]" /> {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <a href={pricing.trialUrl} target="_blank" rel="noopener noreferrer" className="ggm-btn-primary mt-8" data-testid="project-pricing-trial-btn">
          Start 14-day free trial <ArrowUpRight size={16} />
        </a>
      </div>
    </section>
  );
};
